(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["identity-campaign"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('identity-banner-video')) {
  customElements.define('identity-banner-video', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const video = this.querySelector('video');
      video.muted = true;
      video.playsInline = true;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.autoplay = false;
        video.pause();
      } else {
        video.play().catch(() => {});
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["identity-gift-card"]) return;
  try {
    
  if (!customElements.get('identity-gift')) {
    customElements.define('identity-gift', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const form = this.querySelector('form');
        const art = this.querySelector('.ib-gift-art');
        const recipient = this.querySelector('[data-recipient-fields]');
        const message = recipient.querySelector('textarea');
        let lastMessage = message.value;
        const offset = this.querySelector('[data-gift-offset]');
        offset.value = new Date().getTimezoneOffset();
        offset.disabled = false;
        const date = recipient.querySelector('input[type="date"]');
        const isoLocal = d => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
        const today = new Date();
        const latest = new Date();
        latest.setDate(latest.getDate()+90);
        date.min = isoLocal(today);
        date.max = isoLocal(latest);
        this.querySelector('.ib-native-gift__self').hidden = false;
        form.addEventListener('change', event => {
          const input = event.target;
          if (input.matches('[data-headline]')) {
            art.dataset.design = input.value;
            art.querySelector('[data-gift-headline]').textContent = input.dataset.headline;
            if (message.value === lastMessage) message.value = input.dataset.message;
            lastMessage = input.dataset.message;
          }
          if (input.matches('[data-amount]')) art.querySelector('[data-gift-value]').textContent = input.dataset.amount;
          if (input.matches('[data-gift-self]')) {
            recipient.hidden = input.checked;
            recipient.querySelectorAll('input,textarea').forEach(field => field.disabled = input.checked);
          }
        });
        form.addEventListener('submit', async event => {
          event.preventDefault();
          if (this.submitting || !form.reportValidity()) return;
          const button = this.querySelector('[data-gift-submit]');
          const error = this.querySelector('[data-gift-error]');
          const checkBag = this.querySelector('[data-check-bag]');
          const data = new FormData(form);
          data.delete('return_to');
          this.submitting = true;
          button.disabled = true;
          button.setAttribute('aria-busy','true');
          button.textContent = button.dataset.loading;
          error.hidden = true;
          checkBag.hidden = true;
          try {
            const response = await fetch(this.dataset.addUrl,{method:'POST',body:data,headers:{Accept:'application/json'}});
            const result = await response.json();
            if (!response.ok || result.status) {
              const detail = result.description || result.message;
              error.textContent = typeof detail === 'string' ? detail : error.dataset.defaultError;
              if (detail && typeof detail === 'object') error.textContent = Object.values(detail).flat().join(' ');
              error.hidden = false;
              error.focus();
            } else {
              window.location.assign(this.dataset.cartUrl);
              return;
            }
          } catch (_) {
            error.textContent = error.dataset.networkError;
            error.hidden = false;
            checkBag.hidden = false;
            error.focus();
          }
          this.submitting = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = button.dataset.label;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
